import React, { Component } from 'react';
import radium, { Style } from 'radium';
import { Radio } from '@lyearn-team/frontend-components';

class QuizReviewCard extends Component {
  static styles = {};

  onRadioSelectionChange = (e) => {
    this.props.getAllPeerQResponse(this.props.index, parseInt(e.target.value, 10), 'quiz');
  };

  render() {
    const styles = QuizReviewCard.styles;
    const options = this.props.options;

    return (
      <div className="sliderReviewCard">
        <div className="sliderContainer">
          {options.map((option, i) => {
            const label = option.text + ' (' + this.props.maxScore * option.relativeScore + ' points)';
            return (
              <Radio
                value={i.toString()}
                name="quizButton"
                label={label}
                onChange={this.onRadioSelectionChange}
                style={{ marginTop: '10px' }}
              />
            );
          })}
        </div>
        <Style rules={styles.classBased} scopeSelector=".sliderReviewCard" />
      </div>
    );
  }
}

QuizReviewCard.styles = {
  classBased: {
    '.sliderContainer': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  inputStyle: {
    border: '1px solid #b5bdc4'
  },
  labelStyle: {
    fontSize: '15px',
    lineHeight: '18px',
    color: 'rgba(0, 0, 0, 0.5)',
    width: 'auto',
    display: 'flex',
    alignItems: 'center'
  },
  marginBottom14: {
    marginBottom: '14px'
  },
  marginBottomZero: {
    marginBottom: '0px'
  }
};

export default radium(QuizReviewCard);
